export const siteInfo = {
  name: '黑料吃瓜',
  fullName: '黑料吃瓜·最新娱乐爆料聚合平台',
  tagline: '吃瓜群众必备的娱乐爆料阵地',
  description: '黑料吃瓜专属阵地，汇聚娱乐圈最新黑料吃瓜内容，明星八卦、网红翻车、热门瓜情实时更新。最劲爆的黑料吃瓜资讯一站搞定，每日新鲜出炉。',
  url: 'https://heiliao-chigua.com',
  logo: '黑料吃瓜',
  founded: '2024',
  email: 'contact@heiliao-chigua.com',
  phone: '400-888-6666',
  address: '北京市朝阳区建国路88号SOHO现代城A座1808室',
  socialMedia: {
    weibo: 'https://weibo.com/heiliao-chigua',
    wechat: 'heiliao_chigua',
    douyin: 'heiliao_chigua',
  },
};

export const aboutContent = {
  brandIntro: {
    title: '品牌介绍',
    paragraphs: [
      '黑料吃瓜成立于2024年，是国内领先的娱乐爆料聚合平台，致力于为广大"吃瓜群众"提供最新、最全、最劲爆的娱乐资讯。我们的编辑团队由资深娱乐记者和自媒体人组成，全天候追踪娱乐圈最新动态。',
      '平台涵盖明星八卦、网红翻车、热门瓜情、综艺爆料、影视圈等多个板块，每日更新数十条独家及精选内容。无论是最新恋情曝光、明星人设崩塌，还是网红带货翻车，黑料吃瓜总能第一时间为您呈现。',
      '我们秉持"真实、快速、有趣"的内容理念，在确保信息准确性的前提下，用最生动有趣的方式呈现每一条八卦新闻。我们的目标是成为华语世界最有影响力的娱乐资讯平台之一。',
    ],
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20media%20newsroom%20with%20multiple%20screens%20displaying%20entertainment%20news%2C%20journalists%20working%20at%20desks%2C%20warm%20atmospheric%20lighting%2C%20professional%20yet%20vibrant%20workspace%2C%20creative%20office%20design&width=800&height=500&seq=about-brand-intro&orientation=landscape',
  },
  reputation: {
    title: '口碑声誉',
    stats: [
      { label: '日均访问量', value: '500万+' },
      { label: '注册用户', value: '2000万+' },
      { label: '日均更新', value: '50+条' },
      { label: '合作媒体', value: '100+' },
    ],
    testimonials: [
      {
        quote: '黑料吃瓜是我每天必刷的平台，消息又快又准，追八卦就靠它了！',
        author: '资深吃瓜群众 @小甜甜',
      },
      {
        quote: '作为娱乐记者，我每天都会关注黑料吃瓜的更新，很多独家新闻都是从他们这里最先曝出来的。',
        author: '某娱乐周刊记者 李先生',
      },
      {
        quote: '信息更新速度非常快，分类清晰，界面简洁好用，体验感很好。',
        author: '互联网从业者 王女士',
      },
    ],
  },
  contact: {
    title: '联系我们',
    description: '如果您有任何爆料线索、合作意向或意见建议，欢迎通过以下方式联系我们。我们期待与您的沟通！',
    email: 'contact@heiliao-chigua.com',
    phone: '400-888-6666',
    address: '北京市朝阳区建国路88号SOHO现代城A座1808室',
    workingHours: '周一至周五 9:00 - 18:00',
  },
};

export const faqs = [
  {
    question: '黑料吃瓜的内容来源是什么？',
    answer: '我们的内容来源于多个渠道，包括自有编辑团队采编、合作媒体供稿、用户投稿爆料以及公开信息的整理汇编。所有内容发布前均经过编辑审核，确保信息的基本真实性。',
  },
  {
    question: '如何向黑料吃瓜提供爆料线索？',
    answer: '您可以通过以下方式向我们提供爆料：发送邮件至 tips@heiliao-chigua.com，或通过网站底部的"联系我们"表单提交。我们承诺对爆料人信息严格保密。',
  },
  {
    question: '黑料吃瓜的内容更新频率如何？',
    answer: '平台实行全天候更新机制，编辑团队7×24小时追踪娱乐圈最新动态。通常每天更新50条以上内容，重大突发事件会在15分钟内完成报道发布。',
  },
  {
    question: '如何申请成为黑料吃瓜的专栏作者？',
    answer: '我们欢迎有才华的娱乐内容创作者加入。请将您的个人简介和代表作品发送至 hr@heiliao-chigua.com，我们的编辑团队会在7个工作日内进行审核并回复。',
  },
  {
    question: '发现不实信息应该如何反馈？',
    answer: '如果您发现平台上的内容存在不实信息，可以通过每篇文章底部的"举报"按钮进行反馈，或发送邮件至 factcheck@heiliao-chigua.com。我们将在核实后第一时间处理。',
  },
];